module.exports = __webpack_public_path__ + "media/rock-scrape-cut.4c5f717d.mp3";